import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=1a9d3a43"
import script from "./createForm.vue?vue&type=script&lang=js"
export * from "./createForm.vue?vue&type=script&lang=js"
import style0 from "./createForm.vue?vue&type=style&index=0&id=1a9d3a43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports